export default "__VITE_ASSET__780d837c__"